// src/pages/Pricing/PaymentCancel.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen bg-brand-dark flex items-center justify-center text-white">
            <div className="text-center p-8 bg-slate-800 rounded-lg">
                <XCircle className="mx-auto h-16 w-16 text-red-400" />
                <h1 className="mt-4 text-3xl font-bold">{t('payment.cancelTitle')}</h1>
                <p className="mt-2 text-slate-300">{t('payment.cancelDesc')}</p>
                <Link to="/purchase-credits" className="mt-8 inline-block px-6 py-2 bg-brand-orange rounded-md font-semibold">
                    {t('payment.tryAgain')}
                </Link>
            </div>
        </div>
    );
};

export default PaymentCancel;